import { render } from "./SignUpFormStackView.vue?vue&type=template&id=2e87da10&scoped=true"
import script from "./SignUpFormStackView.vue?vue&type=script&lang=js"
export * from "./SignUpFormStackView.vue?vue&type=script&lang=js"

import "./SignUpFormStackView.vue?vue&type=style&index=0&id=2e87da10&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e87da10"]])

export default __exports__